var wellKnownSymbol = require('../internals/well-known-symbol');

exports.f = wellKnownSymbol;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@drawbotics/jakte-plugin-user-agent/node_modules/core-js/internals/wrapped-well-known-symbol.js
// module id = 288
// module chunks = 0